module.exports = __webpack_public_path__ + "media/images/lb/376-f7a2bdcaf354a52684e2b998e8bb408a.svg";